import { API_REST_METHODS } from "../constants";
import { AnalyticsEvent } from "../types";
import fetcher from "./fetcher";

const postRequest = (url: string, { arg }: { arg: any }) =>
    fetcher(url, {
        options: {
            method: API_REST_METHODS.POST,
            body: JSON.stringify(arg),
        },
    });

export const useTrackEvent = () => {
    // const { user } = useCurrentUser();

    // const { trigger: triggerTrackEvent } = useSWRMutation(
    //     "/api/analytics/trackEvent",
    //     postRequest
    // );

    const trackEvent = (event: AnalyticsEvent, data?: any) => {
        // if (getEnvironment() === ENVIRONMENTS.PRODUCTION) {
        //     triggerTrackEvent({
        //         eventName: event.name,
        //         eventData: {
        //             distinct_id: user?.id,
        //             Description: event.description,
        //             ...data,
        //         },
        //     });
        // } else {
        //     console.log("Track event skipped in development and staging:", {
        //         eventName: event.name,
        //         eventData: {
        //             distinct_id: user?.id,
        //             Description: event.description,
        //             ...data,
        //         },
        //     });
        // }
    };

    return { trackEvent };
};
